
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"},"content":"<path d=\"M22.8 14.6l-7.6-7.6-.7.7 5.5 6.6h-14v1.5h14l-5.5 6.6.7.7 7.6-7.6v-.9\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
